import { NgModule } from "@angular/core";
import { NavBarComponent } from "./nav-bar.component";
import { MenuBarComponent } from "./menu-bar/menu-bar";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { MenuAccountComponent } from "./menu-account/menu-account.component";
import { PipeModule } from "src/app/ui/pipes/pipe.module";
import { ImgSvgComponent } from "../../img-svg/img-svg.component";
import { NewsPanelComponent } from "../../news-panel/news-panel.component";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
  declarations: [NavBarComponent, MenuBarComponent, MenuAccountComponent, ImgSvgComponent, NewsPanelComponent],
  imports: [
    MatIconModule,
    MatMenuModule,
    MatBadgeModule,
    MatButtonModule,
    CommonModule,
    FlexLayoutModule,
    MatDividerModule,
    MatTooltipModule,
    PipeModule,
  ],
  exports: [NavBarComponent, MatBadgeModule, MenuBarComponent, ImgSvgComponent, NewsPanelComponent],
})
export class NavBarModule {}
